import type { MemberPurchaseOrderApiResponse } from 'tradera/state/services/types/webapi-member-generated';
import type {
    CreateResellDraftFromItemApiResponse,
    CreateResellDraftFromItemApiRequest,
    CreateDraftFromExtendedLifeTransactionApiRequest,
    CreateDraftFromExtendedLifeTransactionApiResponse
} from 'tradera/state/services/types/webapi-selling-generated';

import { createApi } from '@reduxjs/toolkit/query/react';
import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';

export interface MemberPurchaseOrderApiRequest {
    purchaseOrderId: string;
}

export const resellApi = createApi({
    reducerPath: 'resellApi',
    baseQuery: isomorphicWebApiBaseQuery,
    endpoints: (builder) => ({
        getItems: builder.query<MemberPurchaseOrderApiResponse, string>({
            query: (purchaseOrderId) =>
                `/api/webapi/member/purchaseorder?purchaseOrderId=${purchaseOrderId}`
        }),
        createDraftFromItem: builder.mutation<
            CreateResellDraftFromItemApiResponse,
            CreateResellDraftFromItemApiRequest
        >({
            query: (params) => {
                return {
                    url: '/api/webapi/selling/resell',
                    method: 'POST',
                    body: params
                };
            }
        }),
        createDraftFromExtendedLifeTransaction: builder.mutation<
            CreateDraftFromExtendedLifeTransactionApiResponse,
            CreateDraftFromExtendedLifeTransactionApiRequest
        >({
            query: (params) => ({
                url: '/api/webapi/selling/drafts/from-extended-life-transaction',
                method: 'POST',
                body: params
            })
        })
    })
});

export const {
    useGetItemsQuery,
    useCreateDraftFromItemMutation,
    useCreateDraftFromExtendedLifeTransactionMutation,
    endpoints
} = resellApi;
